<template>
  <div>
    <v-card-title>
      <v-spacer />
      <export-as-csv
        :headers="headersForCSV"
        :data="dataForCSV"
        :file-name="`scanned-products-per-seller-${startDate}-to-${endDate}`"
      />
    </v-card-title>

    <v-container fluid>
      <v-row>
        <v-col lg="1" md="3" sm="6">
          <v-btn color="primary" @click="expandedFilters = !expandedFilters">
            {{ $t('customs.salesBoard.filters') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="filters" :class="{ 'expand-filters': expandedFilters }">
      <v-row align="center">
        <!-- Seller filter -->
        <v-col lg="3" md="6" sm="12" cols="12">
          <v-text-field
            v-model="scannedProductsFilters.sellerFilter"
            :label="$t('customs.salesBoard.searchBySeller')"
          />
        </v-col>

        <!-- Store filter -->
        <v-col lg="3" md="6" sm="12" cols="12">
          <v-text-field v-model="scannedProductsFilters.storeFilter" :label="$t('customs.salesBoard.searchByStore')" />
        </v-col>
      </v-row>
    </v-container>

    <!-- Top products board -->
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="filteredScannedProducts"
          item-key="sellerId"
          :loading="loading"
          :options="{ sortBy: ['sellerName'], sortDesc: [false] }"
          :footer-props="{
            'items-per-page-options': rowsPerPage,
            'items-per-page-text': $t('customs.salesBoard.rowsPerPage')
          }"
          class="elevation-0 table-striped border-radius6"
        >
          <template v-slot:item="{ item }">
            <!-- For each product line -->
            <tr>
              <td class="text-center">{{ item.sellerName }}</td>
              <td class="text-center">{{ item.storeName | capitalize() }}</td>
              <td class="text-center">{{ item.scanCountScannedProduct }}</td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <v-divider />
    </v-card-text>
  </div>
</template>

<script>
  import { Helpers } from '@/mixins/Helpers.js'
  import ExportAsCsv from '@/components/ExportAsCsv.vue'
  const _ = require('lodash')

  export default {
    name: 'ScannedProductsPerSellerIndicator',
    props: {
      scannedProducts: Array,
      startDate: String,
      endDate: String,
      loading: Boolean
    },
    components: {
      ExportAsCsv
    },
    mixins: [Helpers],
    data() {
      return {
        expandedFilters: false,
        filteredScannedProducts: [],
        scannedProductsFilters: {
          sellerFilter: '',
          storeFilter: ''
        },
        rowsPerPage: [10, 20, 30, 40, 50, { text: 'All', value: -1 }],
        headers: [
          {
            text: this.$t('customs.scannedProducts.seller'),
            value: 'sellerName',
            sortable: true,
            align: 'center'
          },
          {
            text: this.$t('customs.scannedProducts.store'),
            value: 'storeName',
            sortable: true,
            align: 'center'
          },
          {
            text: this.$t('customs.scannedProducts.scanNumber'),
            value: 'scanCountScannedProduct',
            sortable: true,
            align: 'center'
          }
        ],
        headersForCSV: ['Seller', 'Store', 'ScanNumber']
      }
    },
    computed: {
      scannedProductsPerSeller() {
        if (this.scannedProducts && this.scannedProducts.length > 0) {
          let scannedProductsPerSeller = []

          for (let scan of this.scannedProducts) {
            let sellerIndex = scannedProductsPerSeller.findIndex(saleStat => saleStat.sellerId === scan.id_user)
            if (sellerIndex >= 0) {
              scannedProductsPerSeller[sellerIndex].scanCountScannedProduct += scan.scan_count_scanned_product
            } else {
              scannedProductsPerSeller.push({
                sellerId: scan.id_user,
                sellerName: scan.user.fullname_user,
                storeName: scan.store.name_store,
                scanCountScannedProduct: scan.scan_count_scanned_product
              })
            }
          }

          return scannedProductsPerSeller
        } else {
          return []
        }
      },
      dataForCSV() {
        let data = []
        for (let product of this.scannedProductsPerSeller) {
          let productData = []
          productData.push(product.sellerName)
          productData.push(product.storeName)
          productData.push(product.scanCountScannedProduct)
          data.push(productData)
        }
        return data
      }
    },
    methods: {
      formatScannedProducts(newScannedProducts) {
        if (newScannedProducts.length > 0) {
          this.filteredScannedProducts = _.cloneDeep(this.scannedProductsPerSeller)
        } else {
          this.filteredScannedProducts = []
        }
      }
    },
    mounted() {
      this.formatScannedProducts(this.scannedProducts)
    },
    watch: {
      scannedProducts(newScannedProducts) {
        this.formatScannedProducts(newScannedProducts)
      },
      scannedProductsFilters: {
        handler(newFilters) {
          this.filteredScannedProducts = this.scannedProductsPerSeller.filter(scannedProduct => {
            if (newFilters.sellerFilter !== '') {
              if (!scannedProduct.sellerName.toLowerCase().includes(newFilters.sellerFilter.toLowerCase())) {
                return false
              }
            }
            if (newFilters.storeFilter !== '') {
              if (!scannedProduct.storeName.toLowerCase().includes(newFilters.storeFilter.toLowerCase())) {
                return false
              }
            }
            return true
          })
        },
        deep: true
      }
    }
  }
</script>

<style>
  .filters {
    overflow: hidden;
    max-height: 0;
    transition-property: max-height;
    transition-duration: 0.5s;
  }

  .expand-filters {
    height: auto;
    max-height: 400px;
    overflow-y: auto;
    transition-property: max-height;
    transition-duration: 0.5s;
  }
</style>
